import { c as _c } from "react/compiler-runtime";
// ===============================================
// THIS IS A GENERATED FILE - Do NOT edit manually
//
// @see libs/data-access/generator/README.md
//
// ===============================================
import { useQuery } from '@tanstack/react-query';
import { createUrlFromPattern } from '@cntxt/domains/access-control';
import { axiosFetch } from '@cntxt/shared/infrastructure/api/http';
import { APIReturnType } from '@cntxt/shared/infrastructure/api/routing';
import { API_BASE } from '../../../shared/constants';
import { getNotificationUnreadCounts as APIHandler, EndpointParams } from '../api/getNotificationUnreadCounts';
import { notificationsKeys } from './keys';
const network = ({
  signal
}: {
  signal?: AbortSignal;
} = {}): APIReturnType<typeof APIHandler, EndpointParams> => {
  const apiUrl = createUrlFromPattern(`${API_BASE}notifications/unread-counts`, {});
  return axiosFetch({
    apiUrl,
    method: 'GET',
    signal
  });
};
export const useGetNotificationUnreadCountsQuery = options => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = notificationsKeys.notificationUnreadCounts();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = options?.enabled;
  const t2 = options?.refetchInterval;
  const t3 = options?.refetchOnWindowFocus;
  const t4 = options?.refetchOnMount;
  const t5 = options?.refetchOnReconnect;
  const t6 = options?.staleTime;
  let t7;
  if ($[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5 || $[6] !== t6) {
    t7 = {
      queryKey: t0,
      queryFn: _temp,
      enabled: t1,
      refetchInterval: t2,
      refetchOnWindowFocus: t3,
      refetchOnMount: t4,
      refetchOnReconnect: t5,
      staleTime: t6
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return useQuery(t7);
};
export const getNotificationUnreadCountsQuery = network;
function _temp() {
  return network();
}